<template>
    <main-header
        :title="title"
        iconLeftBtn="el-icon-back"
        @onClickLeftBtn="onClickLeftBtn"
    >
        <div
            class="crm-content-container crm-content-container--without-footer"
        >
            <data-form style="z-index:1" :is_profile="true" expanded>
                <div v-if="userInfo" id="profile-form">
                    <el-form ref="uploadImage">
                        <el-form-item prop="imageProfile" class="text-center">
                            <div
                                class="crm-profile-upload"
                                @click="dropImageProfile"
                            >
                                <div
                                    class="crm-profile-upload-icon"
                                    style="z-index: 1"
                                    v-show="!isUploading"
                                >
                                    <svg
                                        width="14"
                                        height="12"
                                        viewBox="0 0 14 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M10.6266 2.1576C10.6533 2.20422 10.6999 2.23751 10.7599 2.23751C12.3599 2.23751 13.6666 3.54273 13.6666 5.14095V9.09656C13.6666 10.6948 12.3599 12 10.7599 12H3.23992C1.63325 12 0.333252 10.6948 0.333252 9.09656V5.14095C0.333252 3.54273 1.63325 2.23751 3.23992 2.23751C3.29325 2.23751 3.34659 2.21088 3.36659 2.1576L3.40659 2.07769C3.42957 2.02932 3.45316 1.97963 3.4771 1.92919C3.64765 1.56996 3.83633 1.17253 3.95325 0.938957C4.25992 0.339623 4.77992 0.00665927 5.42659 0H8.56659C9.21325 0.00665927 9.73992 0.339623 10.0466 0.938957C10.1516 1.14872 10.3116 1.48661 10.4657 1.81228C10.4976 1.87948 10.5291 1.94617 10.5599 2.0111L10.6266 2.1576ZM10.1399 4.71478C10.1399 5.04775 10.4066 5.31412 10.7399 5.31412C11.0733 5.31412 11.3466 5.04775 11.3466 4.71478C11.3466 4.38182 11.0733 4.10879 10.7399 4.10879C10.4066 4.10879 10.1399 4.38182 10.1399 4.71478ZM5.84671 5.7469C6.16004 5.43391 6.56671 5.26743 7.00004 5.26743C7.43338 5.26743 7.84004 5.43391 8.14671 5.74024C8.45338 6.04657 8.62004 6.45278 8.62004 6.88563C8.61338 7.77798 7.89338 8.50384 7.00004 8.50384C6.56671 8.50384 6.16004 8.33735 5.85338 8.03103C5.54671 7.7247 5.38004 7.31849 5.38004 6.88563V6.87897C5.37338 6.45944 5.54004 6.05323 5.84671 5.7469ZM8.84675 8.73698C8.37341 9.20978 7.72008 9.50279 7.00008 9.50279C6.30008 9.50279 5.64675 9.22976 5.14675 8.73698C4.65341 8.23753 4.38008 7.58492 4.38008 6.8857C4.37341 6.19314 4.64675 5.54053 5.14008 5.04108C5.64008 4.54164 6.30008 4.26861 7.00008 4.26861C7.70008 4.26861 8.36008 4.54164 8.85341 5.03442C9.34675 5.53387 9.62008 6.19314 9.62008 6.8857C9.61341 7.61156 9.32008 8.26417 8.84675 8.73698Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <el-image
                                    v-loading="isUploading"
                                    fit="cover"
                                    class="crm-profile-img"
                                    :src="
                                        imagePreview
                                            ? imagePreview
                                            : require('@/assets/img/user-default.jpg')
                                    "
                                    @error="onImageError"
                                />
                            </div>
                            <input
                                id="imageProfile"
                                type="file"
                                style="display: none"
                                ref="imageProfile"
                                accept="image/*"
                                @change="imageInput($event)"
                            />
                        </el-form-item>
                    </el-form>
                    <el-form
                        v-loading="isLoadingProfile"
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                    >
                        <el-form-item prop="name">
                            {{ $t('register.name') }}
                            <el-input
                                class="mt-2"
                                v-model="ruleForm.name"
                                type="text"
                                autocomplete="off"
                                :placeholder="placeholder.name"
                                maxlength="50"
                            />
                        </el-form-item>
                        <el-form-item prop="gender">
                            {{ $t('register.gender') }} <br />
                            <el-radio-group
                                v-model="ruleForm.gender"
                                class="mt-3"
                                size="small"
                            >
                                <el-radio :label="1" border>{{
                                    $t('register.male')
                                }}</el-radio>
                                <el-radio :label="2" border>{{
                                    $t('register.female')
                                }}</el-radio>
                                <el-radio :label="0" border>{{
                                    $t('register.not-specified')
                                }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item id="input-datetime" prop="birthdate">
                            {{ $t('register.birthday') }}<br />
                            <el-date-picker
                                class="mt-2"
                                v-model="ruleForm.birthdate"
                                type="date"
                                :placeholder="placeholder.birthdate"
                                format="d MMMM yyyy"
                                value-format="yyyy-MM-dd"
                                :picker-options="datePickerOptions"
                                :default-value="defaultDate"
                                :clearable="false"
                            />
                        </el-form-item>
                        <el-form-item prop="phoneNumber">
                            <el-row type="flex" justify="space-around">
                                <el-col :span="12"
                                    >{{ $t('register.phone-number') }}
                                </el-col>
                                <el-col
                                    :span="12"
                                    :push="9"
                                    style="color: #28B7FF;"
                                    ><span @click="changePhone()">เปลี่ยน</span>
                                </el-col>
                            </el-row>
                            <el-input
                                class="mt-2"
                                v-model="phoneNumber"
                                type="text"
                                pattern="[0-9]*"
                                autocomplete="off"
                                :placeholder="placeholder.mobile"
                                @keypress.native="onlyNumber($event)"
                                :disabled="true"
                            />
                        </el-form-item>
                        <el-form-item prop="email">
                            {{ $t('register.email') }}
                            <el-input
                                class="mt-2"
                                v-model="ruleForm.email"
                                type="email"
                                autocomplete="off"
                                :placeholder="placeholder.email"
                                @input="isEmailDuplicate = false"
                                maxlength="50"
                            />
                        </el-form-item>
                    </el-form>
                </div>
                <el-button
                    :disabled="isLoadingProfile || !isChangeData"
                    type="primary"
                    class="submit-button"
                    :loading="isLoadingProfile"
                    @click="handleSubmit('ruleForm')"
                >
                    {{ $t('profile.save') }}
                </el-button>
            </data-form>
            <WaterMark style="z-index:0" :color="'#CFD0D1'" />
        </div>
    </main-header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DataForm from '@/components/DataForm'
import MainHeader from '@/components/MainHeader'
import GATracking from '@/helper/GATrackingMixins'
import WaterMark from '@/components/WaterMark.vue'

export default {
    components: {
        DataForm,
        MainHeader,
        WaterMark,
    },
    mixins: [GATracking],
    data() {
        const [year, month, day] = [
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
        ]
        const dateFiveYearAgo = new Date(year - 5, month, day)
        return {
            datePickerOptions: {
                disabledDate(date) {
                    return date > dateFiveYearAgo
                },
            },
            defaultDate: dateFiveYearAgo,
            title: this.$t('profile.profile'),
            crm_public_path: process.env.VUE_APP_S3_PUBLIC_PATH,
            userProfileImageFile: null,
            isLoadingProfile: false,
            isUploading: false,
            phoneNumber: '',
            ruleForm: {
                name: '',
                gender: '',
                birthdate: null,
                email: '',
            },
            placeholder: {
                name: this.$t('register.placeholder-name'),
                gender: this.$t('register.placeholder-gender'),
                birthdate: this.$t('register.placeholder-birthdate'),
                phoneNumber: this.$t('register.placeholder-phone-number'),
                email: this.$t('register.placeholder-email'),
            },
            rules: {
                name: [
                    {
                        required: true,
                        message:
                            '* ' +
                            this.$t('register.please') +
                            this.$t('register.placeholder-name'),
                        trigger: 'blur',
                    },
                    {
                        validator: this.validateIsNotEmptyWithSpace,
                        trigger: 'blur',
                    },
                ],
                gender: [
                    {
                        required: true,
                        message: this.$t('register.placeholder-gender'),
                    },
                ],
                email: [
                    {
                        required: false,
                        type: 'email',
                        message: '* ' + this.$t('register.invalid-email'),
                        trigger: 'blur',
                    },
                ],
            },
            imagePreview: null,
        }
    },
    async mounted() {
        if (this.userInfo) {
            this.imagePreview = this.userInfo.imageKey
            this.ruleForm = {
                name: this.userInfo.name ? this.userInfo.name : '',
                gender:
                    typeof this.userInfo.gender === 'number'
                        ? this.userInfo.gender
                        : 1,
                birthdate: this.userInfo.birthdate,
                email: this.userInfo.email,
                restaurantUUID: this.restaurantInfo.restaurantUUID,
            }
            this.phoneNumber = this.userInfo.phoneNumber
        }
    },
    methods: {
        ...mapActions({
            setProfileData: 'user/setProfileData',
            setUserImage: 'user/setUserImage',
            fetchUserInfo: 'user/fetchUserInfo',
        }),
        onClickLeftBtn() {
            this.trackAccount(6, 'ProfileCRM')
            this.$router.push('Account')
        },
        handleSubmit(formName) {
            this.$refs[formName].validate(valid => {
                this.trackAccount(4, 'ProfileCRM')
                if (valid) {
                    this.isLoadingProfile = true
                    this.ruleForm.email = this.ruleForm.email? this.ruleForm.email : undefined
                    this.setProfileData(this.ruleForm).finally(() => {
                        this.isLoadingProfile = false
                    })
                } else return false
            })
        },
        handleUploadSubmit() {
            this.isUploading = true
            this.setUserImage(this.userProfileImageFile).finally(() => {
                this.isUploading = false
                this.userProfileImageFile = null
            })
        },
        dropImageProfile() {
            this.trackAccount(5, 'ProfileCRM')
            if (this.isUploading) return
            document.getElementById('imageProfile').value = ''
            this.$refs.imageProfile.click()
        },
        imageInput(e) {
            let files = e.target.files || e.dataTransfer.files
            if (!files.length) {
                return
            }
            if (files[0].size > 1048576 * 10) {
                // limit 10MB OR 1048576 Byte And JPEG OR PNG
                this.$message.warning(this.$t('profile.image-exceed') + ' !')
            } else {
                if (
                    [
                        'image/jpeg',
                        'image/jpg',
                        'image/png',
                        'image/gif',
                    ].includes(files[0].type)
                ) {
                    // Set File Before Upload Pass
                    this.userProfileImageFile = files[0]
                    // Preview Image Before Upload
                    this.setPreviewImage(this.userProfileImageFile)
                    // Upload Image
                    this.handleUploadSubmit()
                } else {
                    this.$message.warning(this.$t('profile.file-exceed') + ' !')
                }
            }
        },
        setPreviewImage(file) {
            if (file) {
                this.imagePreview = URL.createObjectURL(file)
            }
        },
        validateIsNotEmptyWithSpace(rule, value, callback) {
            const valueNotSpace = value.replace(/\s/g, '')
            if (valueNotSpace.length === 0) {
                callback(
                    new Error(
                        '* ' +
                            this.$t('register.please') +
                            this.$t('register.placeholder-name'),
                    ),
                )
            }
            callback()
        },
        async onImageError() {
            await this.fetchUserInfo()
        },
        onlyNumber(event) {
            event = event ? event : window.event
            var charCode = event.which ? event.which : event.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault()
            } else {
                return true
            }
        },
        changePhone() {
            this.$router.push({ name: 'ChangePhone' })
        },
    },
    computed: {
        ...mapGetters({
            userInfo: 'user/userInfo',
            restaurantInfo: 'restaurant/restaurantInfo',
        }),
        isChangeData() {
            if (
                this.ruleForm.name === this.userInfo.name &&
                this.ruleForm.gender === this.userInfo.gender &&
                this.ruleForm.birthdate === this.userInfo.birthdate &&
                this.ruleForm.email === this.userInfo.email
            ) {
                return false
            }
            return true
        },
    },
}
</script>

<style scoped>
#profile-form {
    font-size: 16px;
    margin: 15px 0 25px 0;
}

.el-input.is-disabled .el-input__inner {
    background-color: #f6f8fa;
}

#profile-form .el-input__inner {
    font-size: 18px;
}

#profile-form .el-date-editor.el-input,
#profile-form .el-date-editor.el-input__inner {
    width: 100%;
}

#profile-form .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 8px;
}

.crm-profile-upload {
    position: relative;
    width: 90px;
    margin: auto;
}

.crm-profile-img {
    border-radius: 50%;
    height: 90px;
    width: 90px;
    border: 2px solid #dcdfe0;
}

.crm-profile-upload-icon {
    position: absolute;
    bottom: 5px;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--primary);
    color: #fefefe;
    width: 28px;
    height: 28px;
    border-radius: 50%;
}

.crm-upload-btn {
    margin-top: 16px;
    max-width: fit-content;
}

.submit-button {
  font-family: "DB Heavent";
  margin-top: 21px;
  width: 100%;
  height: 44px;
  font-size: 20px;
  font-weight: bold;
}
</style>
